export default {
  home: {
    openFinance: 'Open Finance',
    description:
      'Secure, fast, gas-free on-chain trading with institutional liquidity',

    gasFees: 'Gas Fees',
    whyHelix: 'Why Helix?',
    reimagined: 'Reimagined',
    latestNews: 'Latest News',
    totalVolume: 'Total Volume',
    totalMarkets: 'Total Markets',
    startTrading: 'Start Trading',
    helixDocs: 'Helix Documentation',
    somethingIsBrewing: 'Something is brewing',
    builtForTheCommunity: 'Built for the Community',
    builtForTheCommunityDescription: 'No investors, no VCs, no nonsense.',

    overview: {
      title: 'Why Helix?',
      lpRewardsTitle: 'LP Rewards',
      tradingBotsTitle: 'Trading Bots',
      gasFreeTitle: 'Gas Free Trading',
      tradeStocksTitle: 'Trade Stocks and RWAs',
      lpRewardsDescription: 'Provide liquidity and get paid for it.',
      description: 'Built as top-tier exchange, but fully decentralized.',
      gasFreeDescription:
        'Never worry about gas fees on Helix. Zero gas, always.',
      tradingBotsDescription:
        'Deploy advanced smart on-chain trading strategies in just a click.',
      tradeStocksDescription:
        'Trade stocks and Real World Assets (RWAs) with crypto for faster, cheaper, and more transparent transactions.'
    },

    gettingStarted: {
      title: 'Getting started on Helix',
      injectiveBridge: 'Injective Bridge',
      description: 'Deposit crypto assets to Injective ',
      description2:
        'Bridge USDT and other assets into Helix via the {bridgeLink}.',
      gasRequirement:
        'Make sure you get at least 0.1 INJ to pay for the transaction fee.',
      step1: {
        title: 'Step 1',
        description: 'Visit the Injective Bridge and connect your wallet.'
      },
      step2: {
        title: 'Step 2',
        description:
          'Select the source chain (e.g. Ethereum, Cosmos or Solana).'
      },
      step3: {
        title: 'Step 3',
        description: 'Choose USDT or any other asset'
      },
      step4: {
        title: 'Step 4',
        description:
          'Once complete, return to Helix and check your Balances on the Portfolio page. You are ready to trade!'
      }
    },

    faq: {
      title: 'Frequently Asked Questions',
      or: 'or',
      on: 'on',
      and: 'and',
      here: 'here',
      fullstop: '.',
      accordion1: {
        btc: 'Bitcoin (BTC)',
        eth: 'Ethereum (ETH)',
        inj: 'Injective (INJ)',
        title: 'What is a decentralized cryptocurrency exchange (DEX)?',
        content1:
          'A decentralized exchange (DEX) lets you trade cryptocurrencies like {btc}, {eth} and {inj} directly from your own wallet without intermediaries or custodians.',
        content2:
          'Unlike centralized exchanges (CEXs), DEXs are permissionless, fully transparent, and non-custodial.',
        content3:
          'Helix is a leading DEX built on Injective, offering fast, gas-free, on-chain trading. You stay in control of your assets at all times.'
      },
      accordion2: {
        title: 'What features does Helix offer?',
        featureTitle:
          'Helix offers a seamless and powerful trading experience with advanced features and flexibility:',
        feature1: {
          section1: 'Trade top crypto pairs on',
          section2: 'Spot Markets'
        },
        feature2: {
          section1: 'Use up to',
          section2: '100x leverage',
          section3: 'Perpetual Markets',
          section4: 'including crypto',
          section5: 'stocks',
          section6: 'commodities',
          section7: 'like gold and silver.'
        },
        feature3: {
          section1: 'Automate your strategies with built-in ',
          section2: 'trading bots',
          section3: 'for spot and perpetual markets.'
        },
        feature4: {
          section1: 'Earn through',
          section2: 'LP rewards',
          section3: 'maker rebates',
          section4: 'fee discounts',
          section5: 'by staking INJ.'
        },
        feature5: {
          section1: 'Benefit from a smooth trading flow with',
          section2: 'auto-signing',
          section3: 'and a gas-free experience.'
        },
        feature6: {
          section1: 'Participate in frequent',
          section2: 'trading competitions',
          section3: 'and unlock exclusive rewards.'
        }
      },
      accordion3: {
        title: 'How do I get started with Helix?',
        content1:
          'To start trading on Helix, simply log in using your social account or connect your wallet, then deposit your assets.',
        content2:
          'Follow the complete onboarding guide {here} to get set up step-by-step.'
      },
      accordion4: {
        title: 'How do I get assets onto Helix?',
        optionTitle:
          'To start trading on Helix, you’ll first need to get assets like USDT or INJ on Injective:',
        option1: {
          section1: 'Buy crypto via',
          section2: 'fiat on-ramps',
          section3:
            '(through debit/credit cards, Revolut, Apple Pay, Google Pay & more).'
        },
        option2: {
          section1: 'Use',
          section2: 'Injective Bridge',
          section3: 'to deposit assets from other chains.'
        },
        option3:
          'Alternatively, you can also deposit from different centralized exchanges like Binance, ByBit & more.'
      },
      accordion5: {
        videoTutorialHere: 'video tutorial here',
        title: 'How do I trade cryptocurrencies on Helix?',
        cta: 'Want a full walkthrough? Check out our step-by-step {tutorial}.',
        stepTitle:
          "Trading on Helix is fast, permissionless, and completely gas-free. Here's how to get started:",
        step1: {
          section1: 'Head to',
          section2: 'helixapp.com',
          section3: 'and connect your wallet.'
        },
        step2: {
          section1: 'Deposit or bridge assets like',
          section2: 'USDT',
          section3: 'INJ'
        },
        step3: {
          section1: 'Pick a',
          section2: 'Spot',
          section3: 'Perpetual',
          section4: 'market you want to trade.'
        },
        step4: {
          section1: 'Place a',
          section2: 'limit',
          section3: 'market order',
          section4: 'with just a few clicks.'
        }
      },
      accordion6: {
        title: 'How can I earn rewards on Helix?',
        optionTitle:
          'Helix offers several ways for users to earn by regularly using Helix:',
        option1: {
          section1: 'Trading Competitions',
          section2: 'Join to win real prizes and rank on leaderboards.'
        },
        option2: {
          section1: 'Referral Program',
          section2:
            'Invite friends and earn up to 40% of your referrals’ fees as rewards.'
        },
        option3: {
          section1: 'Staking & Yields',
          section2: 'Stake INJ or deposit USDT for passive rewards.'
        },
        option4: {
          section1: 'Liquidity Incentives',
          section2: 'Participate in campaigns like',
          section3: 'LP Rewards',
          section4: 'and earn weekly rewards.'
        }
      }
    }
  }
}
